<template>
  <div style="font-size: 14px">
    <div v-if="name==='海报'" class="search">
      <van-dropdown-menu active-color="#3974c4">
        <van-dropdown-item v-model="border" :options="posterTypeList" />
        <van-dropdown-item v-model="groupId" :options="groupList" v-if="groupId && name !== '海报'" />
      </van-dropdown-menu>
      <van-search v-model="value" placeholder="搜索" @search="onSearch" @clear="onCancel" shape="round" />
    </div>
    <div v-else>
      <div class="search">
        <van-dropdown-menu active-color="#3974c4">
          <van-dropdown-item v-model="border" :options="typeList" />
        </van-dropdown-menu>
        <van-search v-model="value" placeholder="搜索" @search="onSearch" @clear="onCancel" shape="round" />
      </div>
      <van-dropdown-menu class="search-group" active-color="#3974c4">
        <van-dropdown-item @change="selectDept" v-model="deptId" :options="deptList"
          v-if="border === 3 && deptList.length > 0" />
        <van-dropdown-item :title="groupName" ref="item" v-if="groupList.length > 0">
          <multipleSelect ref="selectChild" :parentType="border" :deptId="deptId" :dataList="groupList"
            :groupItem="groupItem" @getGroupItem="getGroupItem" @getIdName="getIdName"
            @getShowPopupTree="getShowPopupTree">
          </multipleSelect>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>

    <div class="conte" v-for="(item, index) in list" :key="index" @click="showDetail(item)">
      <div style="display:flex">
        <img v-if="name==='海报'" :src="item.imgWithQrcode" alt="" />
        <img v-if="name==='图集' && item.imgList" :src="item.imgList[0].url" alt="" />
        <img v-if="(name==='文章' || name==='文件' || name==='表单') && item.cover" :src="item.cover" alt="" />
        <img v-if="name==='小程序'" :src="item.headImg" alt="" />
      </div>
      <div class="conte-title">
        <span>{{item.name || item.title}}</span>
        <span v-if="name==='小程序'">{{item.title}}</span>
      </div>
      <div style="display: flex;">
        <!-- 视频图集以链接形式发送 -->
        <div v-if="name === '视频' || name=== '图集'" class="copy-btn" @click.stop="sendLink(item)">发送链接</div>
        <!-- 别的类型以链接形式发送 -->
        <div v-if="name === '文章' || name=== '海报' || name=== '表单' || name=== '文件' || name=== '外部链接'" class="copy" @click.stop="sendLink(item)">发送</div>
        <!-- 视频图集直接发送 -->
        <div v-if="name === '视频' || name=== '图集'" class="copy" @click.stop="sendItem(item)">发送</div>
        <!-- 小程序发送 (从详情获取内容)-->
        <div v-if="name === '小程序'" class="copy" @click.stop="showDetail(item)">发送</div>
      </div>
    </div>
    <!-- 海报详情popup -->
    <van-popup v-model="showImage" position="bottom" :style="{ height: '85%' }" style="display: flex;justify-content: center;">
        <img style="max-width: 100%" :src="posterImg" alt="" />
    </van-popup>
    <!-- 图集详情popup -->
    <van-popup v-model="showPopupImage" @click-overlay="closePopupImage" position="bottom" :style="{ height: '85%' }">
      <van-radio-group v-model="radioImage">
        <van-radio v-for="(itemImage, indexImage) in imageList" :key="indexImage" :name="itemImage.id">
          <img style="max-width: 100%" :src="itemImage.url" alt="" />
        </van-radio>
      </van-radio-group>
      <van-button type="info" style="width: 100%;position: fixed;bottom: 0px;" @click="sendImage(radioImage)">
        发送
      </van-button>
    </van-popup>
    <!-- 文章详情popup -->
    <van-popup v-model="showPopup" position="bottom" :style="{ height: '85%' }">
      <div class="popup">
        <van-field class="popup-title" v-model="details.title" input-align="center" rows="1" autosize type="textarea"
          disabled>
        </van-field>
        <van-field class="popup-content" v-html="details.body" rows="1" autosize type="textarea"></van-field>
      </div>
    </van-popup>
    <!-- 视频预览 -->
    <van-popup v-model="showVideo" position="bottom" :style="{ height: '85%' }">
      <video v-if="name==='视频'" style="max-width: 100%" controls="controls" :src="videoUrl">
      </video>
    </van-popup>
    <!-- 表单预览 -->
    <van-popup v-model="showForm" position="bottom" :style="{ height: '85%' }">
      <div class="form_title">{{formTitle}}</div>
      <div class="form_description">{{formDescription}}</div>
      <van-form>
        <div v-for="(item, index) in formList" :key="index">
          <van-field border disabled v-if="item.type === 0" :name="item.name" :label="item.name" v-model="item.value"
            :placeholder="'请填写' + item.name" :rules="[{ required: Boolean(item.isNeed), message: '请填写' }]" />
          <van-field disabled v-if="item.type === 1" rows="1" autosize :label="item.name" v-model="item.value"
            type="textarea" :placeholder="'请输入'+ item.name" />
          <van-field disabled v-if="item.type === 2" type="number" v-model="item.value" :label="item.name"
            :rules="[{ required: Boolean(item.isNeed), message: '请填写' }]" />
          <van-field disabled v-if="item.type === 3" :label="item.name"
            :rules="[{ required: Boolean(item.isNeed), message: '请选择' }]">
            <template #input>
              <van-radio-group disabled v-model="item.value" direction="horizontal">
                <van-radio v-for="(it,index) in item.formProTagReqs" :key="index" :name="it.proValue">{{it.proValue}}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field disabled v-if="item.type === 4" name="checkboxGroup" :label="item.name"
            :rules="[{ required: Boolean(item.isNeed), message: '请选择' }]">
            <template #input>
              <van-checkbox-group disabled v-model="item.value" direction="horizontal">
                <van-checkbox v-for="(it,index) in item.formProTagReqs" :key="index" :name="it.proValue" shape="square">
                  {{it.proValue}}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field disabled v-if="item.type === 5" clickable readonly name="calendar" :label="item.name"
            placeholder="点击选择日期" />
          <van-field readonly clickable v-model="timevalue[index]" v-if="item.type === 6" name="datetimePicker"
            :label="item.name" placeholder="点击选择时间" />
          <van-field v-model="allTime[index]" readonly v-if="item.type === 7" clickable name="datetimePicker"
            :label="item.name" placeholder="点击选择时间" />
        </div>
      </van-form>
    </van-popup>
    <!-- 外部链接详情popup -->
    <van-popup v-model="showLink" position="bottom" :style="{ height: '85%' }">
      <van-field border readonly label="链接标题" :placeholder="details.title" />
      <van-field border readonly label="链接地址" :placeholder="details.url" />
      <van-field border readonly label="描述" :placeholder="details.description" />

    </van-popup>
  </div>
</template>

<script>
import multipleSelect from './multipleSelect.vue'
import { flatten } from '../utils/index'
export default {
  components: { multipleSelect },
  props: {
    name: {
      type: String,
      default: ''
    },
    filterList: {
      type: Array
    },
    href: {
      type: Object,
      default: null
    },
    // border: {
    //   type: Number
    // }
  },
  data () {
    return {
      value: "",
      border: 2,
      list: [],
      typeList: [
        { text: '企业库', value: 2 },
        { text: '经销商库', value: 3 },
        { text: '我的库', value: 1 },
      ],
      posterTypeList: [],
      groupId: null, // 分组名id
      groupList: [], // 分组名
      groupItem: {}, // 三级分类的初始化时接收的组对象
      selectNum: 0,
      showPopupTree: false,
      groupName: '',
      deptId: null,
      deptList: [],
      details: {},
      showPopup: false,
      showImage: false,
      showPopupImage: false,
      imageList: [],
      showVideo: false,
      videoUrl: '',
      showForm: false,
      formTitle: '',
      formDescription: '',
      formList: [],
      showLink:false,
      moren: 'https://scrm-saas-1306604067.cos.ap-guangzhou.myqcloud.com/scrm-ui/weifen-logo.jpg',
      posterImg: '',
      theSelf: false,
      radioImage: '',
      imageData: {}
    }
  },
  watch: {
    filterList (val) {
      this.list = val
    },
    groupId (val) {
      this.list = []
      console.log('11', this.groupId);
      this.$emit('getGroupId', val)

    },
    border (val) {
      this.list = []
      this.$emit('getBorder', this.border)
      if (this.name !== '海报') {
        console.log(this.border)
        if (this.border === 3) {
          this.changeDeptId()
        } else {
          this.deptId = null
          this.changeGroupName()
        }
      }

    },

    "name": {
      immediate: true, // 首次加载的时候执行函数
      handler: function(val) {
        this.deptId = null
        this.selectNum = 0
        this.border = 2
        if (this.name !== '海报') {
          this.changeGroupName()
        }
      }
    },
    deptId (val) {
      this.list = []
      console.log('12', val);
      this.$emit('getDeptId', val)

    },
    selectNum (val) {
      console.log(val, 'val1111111111111111');
    }
  },
  created () {
    this.posterTypeList = this.typeList.filter(item => {
      return item.value === 1 || item.value === 2
    })
    this.name1 = this.name
    this.getJsSDK()
  },
  methods: {
    // 切换库与经销商时，实时更新van-dropdown-item组名
    changeGroupName() {
      this.getGroupList(() => {
          if (this.groupList.length < 1) {
            this.groupId = null
            this.groupItem = {}
            this.groupName = ''
          } else {
            if (this.groupList[0].hasChildren && this.groupList[0].children[0].hasChildren) {
              this.groupId = this.groupList[0].children[0].id
              this.groupItem = this.groupList[0]
              this.groupName = this.groupList[0].text + '/' + this.groupList[0].children[0].text
            } else {
              this.groupId = this.groupList[0].id
              this.groupItem = this.groupList[0]
              this.groupName = this.groupList[0].text
            }
          }
        }
      )
    },
    // 切换经销商
    selectDept (val) {
      this.deptId = val
      this.changeGroupName()
    },
    // 获取经销商列表
    initDeptList () {
      this.$http
        .get("/scrm/v1/wxcp-chat-tool/p/contentShareDeptMulTenancy", {})
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.deptList = []
            res.data.forEach(item => {

              if (item.deptList === null || item.deptList === undefined) {
                item.deptList = []
              }
              if (item.deptList.length > 0) {
                item.deptList.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.deptList.push(item.deptList)
              }

            })
            this.deptList = flatten(this.deptList);
            console.log(this.deptList, 'this.deptList');
            if (this.deptList.length > 0) {
              this.deptList.forEach(item => {
                item.text = item.tenancyName + '/ ' + item.name
                item.value = item.id
              })
              this.deptId = this.deptList[0].id
              this.changeGroupName()
            } else {
              this.groupItem = {}
              this.groupId = null
              this.groupList = []
              this.groupName = ''
              //   this.speechListcontent = []
            }
          }
        });
    },
    changeDeptId () {
      this.selectNum = 1
      this.initDeptList()
    },
    // 接收到子组件传回的数据
    getGroupItem (val) {
      this.groupItem = val
      this.groupId = val.id

      if (val.children === null || val.children === undefined) {
        val.children = []
      }
      if (this.border === 3) {
        if (this.selectNum % 2 !== 1 && val.children.length < 1) {
          this.$refs.item.toggle();
        }
      } else {
        if (this.selectNum > 0 && val.children.length < 1) {
          this.$refs.item.toggle();
        }
      }
      this.selectNum++
    },
    getIdName (val) {
      this.groupName = val.join('/')
    },
    getShowPopupTree (val) {
      this.showPopupTree = val
    },
    // 获取分组
    getGroupList (callback) {
      let url;
      let params = {
        owner: this.border,
        corpId: this.href.corpId,
        deptId: this.deptId,
      };
      if (this.name === '文章') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtArticleTreeMul'
      } else if (this.name === '文件') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtFileTreeMul'
      } else if (this.name === '表单') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtFormTreeMul'
      } else if (this.name === '视频') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtVideoTreeMul'
      } else if (this.name === '图集') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtImgTreeMul'
      } else if (this.name === '外部链接') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtUrlTreeMul'
      } else if (this.name === '小程序') {
        url = '/scrm/v1/wxcp-chat-tool/p/findQwMiniProgramTreeMul'
      }
      this.$http.get(url,
        { params }
      ).then(res => {
        if (res.code === 1) {
          if (this.name === '海报') {
            this.groupList = res.data || []
            this.groupList.forEach(item => {
              item.text = item.text || item.name
              item.value = item.id
            })
          }
          else {
            this.groupList = []
            res.data.forEach(item => {
              if (item.tree === null || item.tree === undefined) {
                item.tree = []
              }
              if (item.tree.length > 0) {
                item.tree.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.groupList.push(item.tree)
              }
            })
            this.groupList = flatten(this.groupList); // arr2 [0, 1, 2, 3, 4, 5]
            if (callback) {
              callback()
            }
          }
        } else {
          this.$toast(`${res.msg}`)
        }
      }).catch((e) => {
        console.log('捕获到的错误', e)
      })
    },
    onSearch () {
      //   this.$emit('getBorder', 2)
      this.$emit('keyword', this.value)
    },
    onCancel () {
      this.value = ''
      this.$emit('keyword', this.value)
    },
    closePopupImage () {
      console.log("触发没")
      this.showPopupImage = false
      this.radioImage = ''
    },
    // 素材详情
    showDetail (item) {
      if (this.name === '文章') {
        this.$http.get('/scrm/v1/wxcp-chat-tool/p/findCtArticleId', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            this.details = res.data
            this.showPopup = true
          }
        })
      }

      if (this.name === '图集') {
        this.$http.get('/scrm/v1/ct-img/m/findById', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            this.imageList = res.data.imgList
            this.showPopupImage = true
          }
        })
      }

      if (this.name === '海报') {
        this.showImage = true
        this.posterImg = item.imgWithQrcode
      }

      if (this.name === '视频') {
        this.showVideo = true
        this.videoUrl = item.url
      }
      if (this.name === '表单') {
        this.$http.get('/scrm/v1/wxcp-chat-tool/p/findCtFormId', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            this.showForm = true
            this.formTitle = res.data.title
            this.formDescription = res.data.description
            this.formList = res.data.formProExports.map(item => {
              if (item.type === 4) {
                // type=4 复选框，要求传入数组
                item.value = []
              } else {
                item.value = ''
              }
              // this.datavalue.push('')
              // this.timevalue.push('')
              // this.allTime.push('')
              return item
            })
          }
        })
      }

      if (this.name === '外部链接') {
        this.$http.get('/scrm/v1/wxcp-chat-tool/p/findCtUrlId', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            console.log(res);
            this.details = res.data
            this.showLink = true
          }
        })
      }
      if (this.name === '小程序') {
        this.$http.get('/scrm/v1/wxcp-chat-tool/p/findQwMiniProgramId', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            this.sendLink(res.data)
          }
        })
      }
    },
    // 发送视频（直接发送）
    sendItem(item) {
      if (this.name === '图集') {
        this.imageData = item // 把此项图集信息保存
        this.showDetail(item)
      } else {
        this.theSelf = true
        this.sendLink(item)
      }
    },
    // 发送图集 （直接发送）
    sendImage (val) { // val为选择的图片id
      //增加素材发送历史
      this.$http.get('/scrm/v1/wxcp-chat-tool/p/addCtContentHistory', {
        params: {
          contentId: val,
          contentType: 19,
          corpId: this.href.corpId,
        }
      }).then(res => {
        if (res.code === 1) {
          //发送成功
        }
      })
      this.$http.get('/scrm/v1/wxcp-chat-tool/p/findMediaId', {
        params: {
          contentId: val,
          contentType: 19,
          corpId: this.href.corpId,
          tenancyId: this.imageData.tenancyId
        }
      }).then(res => {
        if (res.code === 1) {
          wx.invoke('sendChatMessage', {
            msgtype: "image", //消息类型，必填
            image:
            {
              mediaid: res.data, //图片的素材id
            },
          }, function(res) {
            // this.$toast(res.err_msg)
            if (res.err_msg == 'sendChatMessage:ok') {
              //发送成功
            }
          })
        }
      })
    },
    // 素材以链接形式发送
    sendLink (item) {
      console.log(item, 'item');
      let contentType;
      if (this.name === '海报') {
        if (this.border === 2) {
          contentType = 31
        } else {
          contentType = 1
        }
      } else if (this.name === '文件') {
        contentType = 3
      } else if (this.name === '表单') {
        contentType = 2
      } else if (this.name === '视频' && this.theSelf === false) {
        contentType = 16
      } else if (this.name === '视频' && this.theSelf === true) {
        contentType = 15
      } else if (this.name === '文章') {
        contentType = 0
      } else if (this.name === '图集') {
        contentType = 17
      } else if (this.name === '外部链接') {
        contentType = 4
      } else if (this.name === '小程序') {
        contentType = 33
      }
      //增加素材发送历史
      this.$http.get('/scrm/v1/wxcp-chat-tool/p/addCtContentHistory', {
        params: {
          contentId: item.id,
          contentType: contentType,
          corpId: this.href.corpId,
        }
      }).then(res => {
        if (res.code === 1) {
          //发送成功
        }
      })
      // 表单或文章或视频链接或图集
      if (contentType === 0 || contentType === 2 || contentType === 16 || contentType === 17 || contentType === 4) {
        wx.invoke('sendChatMessage', {
          msgtype: "news", //消息类型，必填
          news: {
            link: item.sendUrl, //H5消息页面url 必填
            title: item.title || item.name || '', //H5消息标题.
            desc: item.abs || '', //H5消息摘要
            imgUrl: item.cover || this.moren, //H5消息封面图片URL
          },
        }, function(res) {
          // this.$toast(res.err_msg)
          if (res.err_msg == 'sendChatMessage:ok') {
            //发送成功
          }
        })
      } else if (contentType === 1 || contentType === 31 || contentType === 3 || contentType === 15) {
        this.$http.get('/scrm/v1/wxcp-chat-tool/p/findMediaId', {
          params: {
            contentId: item.id,
            contentType: contentType,
            corpId: this.href.corpId,
            tenancyId: item.tenancyId
          }
        }).then(res => {
          if (res.code === 1) {
            // 图片
            if (contentType === 1 || contentType === 31) {
              wx.invoke('sendChatMessage', {
                msgtype: "image", //消息类型，必填
                image:
                {
                  mediaid: res.data, //图片的素材id
                },
              }, function(res) {
                // this.$toast(res.err_msg)
                if (res.err_msg == 'sendChatMessage:ok') {
                  //发送成功
                }
              })
            }
            // 文件
            if (contentType === 3) {
              wx.invoke('sendChatMessage', {
                msgtype: "file", //消息类型，必填
                file:
                {
                  mediaid: res.data, //文件的素材id
                },
              }, function(res) {
                // this.$toast(res.err_msg)
                if (res.err_msg == 'sendChatMessage:ok') {
                  //发送成功
                }
              })
            }
            // 原生视频格式
            if (contentType === 15) {
              console.log('进来了contentType === 15', res)
              wx.invoke('sendChatMessage', {
                msgtype: "video", //消息类型，必填
                video: {
                  mediaid: res.data
                },
              }, function(res) {
                console.log('信息打印：', res)
                if (res.err_msg == 'sendChatMessage:ok') {
                  //发送成功
                  this.theSelf = false
                } else {
                  console.log('错误信息:', res)
                }
              })
            }
          } else {
            this.$toast(res.msg)
            this.theSelf = false
          }
        })
      } else if (contentType === 33) {
        // 小程序
        let that = this
        wx.invoke('sendChatMessage', {
          msgtype: "miniprogram", //消息类型，必填
          miniprogram: {
            appid: item.wxId, //H5消息页面url 必填
            title: item.title || item.name || '', //H5消息标题.
            imgUrl: item.headImg || '', //H5消息封面图片URL
            page: item.enterPoint || '', //H5消息摘要
          },
        }, function(res) {
          // this.$toast(res.err_msg)
          if (res.err_msg == 'sendChatMessage:ok') {
            //发送成功
          } else {
            // console.log('错误信息', res)
            that.$toast({
              message: '该小程序未添加到应用'
            })
          }
        })
      }
    },
    //获取jsSDK信息
    getJsSDK () {
      this.$http.get('/scrm/v1/wxcp-corp/p/getJsSDK', {
        params: {
          corpId: this.href.corpId,
          url: window.location.href.split('#')[0] //'http://scrm-wxwork-ui.ngrok.gznino.com:8080/'
        }
      }).then(res => {
        if (res.code === 1) {
          this.config = res.data
          this.getconfig()
        }
      })
    },
    getconfig () {
      wx.config({
        beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.config.corpid, // 必填，企业微信的corpID
        timestamp: this.config.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.config.nonceStr, // 必填，生成签名的随机串
        signature: this.config.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ['agentConfig'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      })
      let that = this
      wx.ready(function() {
        wx.agentConfig({
          corpid: that.config.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: that.config.agentId, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: that.config.timestamp, // 必填，生成签名的时间戳
          nonceStr: that.config.nonceStr, // 必填，生成签名的随机串
          signature: that.config.agentSignature,// 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ['selectExternalContact', 'sendChatMessage'], //必填
          success: function(res) {
            // 回调
          },
          fail: function(res) {
            if (res.errMsg.indexOf('function not exist') > -1) {
              alert('版本过低请升级')
            }
          }
        })

      })

    },
  }}
</script>
 
<style lang="less" scoped>
.box {
  display: flex;
  font-size: 14px;
  padding: 20px 13px;
  width: 100%;
  .con {
    width: 30%;
    height: 30px;
    margin-right: 15px;
    background-color: #f0f0f2;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
  }
  .con_color {
    width: 30%;
    height: 30px;
    margin-right: 15px;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
    background-color: #e6e6ff;
    border: 1px solid #9494e8;
  }
}
.search {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ededed;
  /deep/ .van-dropdown-menu__bar {
    width: 200px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
  }
}
.search-group {
  /deep/ .van-dropdown-menu__bar {
    // width: 200px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
    font-size: 15px;
  }
}
.conte {
  padding: 18px 10px;
  border-bottom: 1px solid #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    display: block;
    width: 50px;
    height: 50px;
    object-fit: contain;
    border-radius: 5px;
  }
  video {
    display: block;
    width: 50px;
    height: 50px;
  }
}
.conte-title {
  margin: 0 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  span {
    word-break: break-word;
    margin: 5px 0px;
    overflow:hidden;
    display:-webkit-box; 
    text-overflow:ellipsis;//溢出部分用省略号代替
    -webkit-line-clamp:2; //设置文本显示两行
    -webkit-box-orient:vertical;
    white-space:normal;
  }
}
.copy {
  width: 45px;
  height: 25px;
  min-width: 45px;
  margin-left: 10px;
  border: 1px solid #3974c4;
  color: #3974c4;
  font-size: 13px;
  border-radius: 15px;
  text-align: center;
  line-height: 25px;
}
.copy-btn {
  width: 70px;
  height: 25px;
  margin-left: 10px;
  border: 1px solid #3974c4;
  color: #3974c4;
  font-size: 13px;
  border-radius: 15px;
  text-align: center;
  line-height: 25px;
}
.popup {
  padding-bottom: 65px;
  /deep/ img {
    width: 100% !important;
    max-width: 100% !important;
  }
  .popup-title {
    padding: 18px 20px;
    font-weight: bold;
    font-size: 16px;
  }
  /deep/ .van-field__control:disabled {
    color: #323233;
    -webkit-text-fill-color: #323233;
  }
  .popup-content {
    display: block;
    padding: 18px 16px;
    font-size: 14px;
    line-height: 24px;
  }
  .popup-btn {
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
    /deep/.van-button--primary {
      width: 100%;
      background-color: #3974c4;
      border: 0;
      line-height: 45px;
      height: 45px;
    }
  }
}
.form_title {
  text-align: center;
  font-size: 20px;
  margin: 20px auto;
  text-indent: 2rem;
  font-weight: 900 !important;
  padding-right: 2rem;
}
.form_description {
  text-align: center;
  font-size: 14px;
  margin: 10px auto;
}
</style>
